import React, { useState } from 'react';
import {
  Box,
  AppBar,
  Typography,
  Container,
  Button,
  Avatar,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import MenuIcon from '@mui/icons-material/Menu';
import HomeIcon from '@mui/icons-material/Home';
import LogoutIcon from '@mui/icons-material/Logout';
import PeopleIcon from '@mui/icons-material/People';

const Layout = ({ children }) => {
  const { user, logout, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setDrawerOpen(open);
  };

  const menuItems = [
    { text: 'Главная', icon: <HomeIcon />, onClick: () => navigate('/') },
    // Пункт управления пользователями виден только администраторам.
    ...(user?.role === 'admin'
      ? [{ text: 'Пользователи', icon: <PeopleIcon />, onClick: () => navigate('/users') }]
      : []),
    { text: 'Выйти', icon: <LogoutIcon />, onClick: handleLogout }
  ];
  
  const drawer = (
    <Box
      sx={{ width: 250 }}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <Box sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
        <Avatar sx={{ bgcolor: 'secondary.main' }}>
          {user?.username?.charAt(0).toUpperCase() || 'U'}
        </Avatar>
        <Box>
          <Typography variant="subtitle1">{user?.username || 'Пользователь'}</Typography>
          <Typography variant="body2" color="text.secondary">
            {user?.role || 'Роль не указана'}
          </Typography>
        </Box>
      </Box>
      <List>
        {menuItems.map((item, index) => (
          <ListItem button key={index} onClick={item.onClick}>
            <Box sx={{ mr: 2 }}>{item.icon}</Box>
            <ListItemText primary={item.text} />
          </ListItem>
        ))}
      </List>
    </Box>
  );
  
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppBar position="static">
        {isMobile && isAuthenticated && (
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={toggleDrawer(true)}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
        )}
        
        <Typography 
          variant={isMobile ? "subtitle1" : "h6"} 
          sx={{ 
            flexGrow: 1,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}
        >
          Система мониторинга оптических сетей
        </Typography>
        
        {isAuthenticated && !isMobile && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Avatar sx={{ width: 32, height: 32, bgcolor: 'secondary.main' }}>
                {user.username.charAt(0).toUpperCase()}
              </Avatar>
              <Typography variant="body2">
                {user.username} ({user.role})
              </Typography>
            </Box>
            {user?.role === 'admin' && (
              <Button color="inherit" startIcon={<PeopleIcon />} onClick={() => navigate('/users')}>
                Пользователи
              </Button>
            )}
            <Button color="inherit" onClick={handleLogout}>
              Выйти
            </Button>
          </Box>
        )}
      </AppBar>
      
      {isAuthenticated && (
        <Drawer
          anchor="left"
          open={drawerOpen}
          onClose={toggleDrawer(false)}
        >
          {drawer}
        </Drawer>
      )}
      
      <Container 
        maxWidth="xl" 
        sx={{ 
          mt: { xs: 2, sm: 4 }, 
          mb: { xs: 2, sm: 4 }, 
          flex: 1,
          px: { xs: 1, sm: 2, md: 3 }
        }}
      >
        {children}
      </Container>
    </Box>
  );
};

export default Layout; 